module.exports = __webpack_public_path__ + "img/blank.edeb00ae.png";